import { render } from "./BlockedDepartments.vue?vue&type=template&id=4e31a9ba&scoped=true&ts=true"
import script from "./BlockedDepartments.vue?vue&type=script&lang=ts"
export * from "./BlockedDepartments.vue?vue&type=script&lang=ts"

import "./BlockedDepartments.vue?vue&type=style&index=0&id=4e31a9ba&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e31a9ba"]])

export default __exports__